import {
  AccountGetMeResponseData,
  AccountGetMeResponseDto,
} from '@services/dto/account';

export const accountGetMeResponseFromDto = (
  dto: AccountGetMeResponseDto
): AccountGetMeResponseData => {
  return dto.data;
};
